import VesselForecastAPI from './vessel-forecast.api'

export default VesselForecastAPI
